import strings from '../../Localization/Localization';

import { form as _previousPricesForm } from './appointmentActionPreviousPrices';

import { fetchTicketGroups } from '../../API/TicketGroups';
import { fetchFamilies } from '../../API/ProductFamilies';
import { fetchSubFamilies } from '../../API/ProductSubFamilies';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.appointmentAction.name.label,
  validators: [
    {
      id: 'assertEmpty',
      type: 'lengthMin',
      conf: {
        min:1
      },
      invalidFeedback: strings.form.appointmentAction.name.invalid.assertEmpty,
      defaultValue: false
    },
  ]
}

let code = {
  fieldKey: "code",
  type: "text",
  label: strings.form.appointmentAction.code.label,
  validators: [
    {
      id: 'assertEmpty',
      type: 'lengthMin',
      conf: {
        min:1
      },
      invalidFeedback: strings.form.appointmentAction.code.invalid.assertEmpty,
      defaultValue: false
    },
  ]
}

let description = {
  fieldKey: "description",
  type: "textarea",
  label: strings.form.appointmentAction.description.label,
  validators: [
    {
      id: 'assertEmpty',
      type: 'lengthMin',
      conf: {
        min:1
      },
      invalidFeedback: strings.form.appointmentAction.description.invalid.assertEmpty,
      defaultValue: false
    },
  ]
}

let price = {
  fieldKey: "price",
  type: "price",
  label: strings.form.appointmentAction.price.label,
  validators: []
}

let quantityCredit = {
  fieldKey: "quantity_credit",
  type: "text",
  label: strings.form.appointmentAction.quantityCredit.label,
  validators: [
    {
      id: 'assertEmpty',
      type: 'regex',
      conf: {
        regex: /^\d+$/
      },
      invalidFeedback: strings.form.appointmentAction.quantityCredit.invalid.assertEmpty,
      defaultValue: false
    },
  ]
}

let active = {
  fieldKey: "active",
  type: "switch",
  label: strings.form.appointmentAction.active.label,
  validators: [],
  defaultValue: false,
}

let lastPriceModifiedAt = {
  fieldKey: "last_price_modified_at",
  type: "date",
  label: strings.form.appointmentAction.lastPriceModifiedAt.label,
  validators: []
}

let previousPrices = {
  fieldKey: "previous_prices",
  type: "array",
  label: "",

  validators: [],

  allowMoreField: false,
  defaultNumberOfField: 0,

  subField: {
    type: "subform",
    label: "Prix #key#",

    validators: [],

    subForm: _previousPricesForm,
  }
}


let allTicketGroup = {
  fieldKey: "all_ticket_group",
  type: "switch",
  label: strings.form.appointmentAction.allTicketGroup.label,
  validators: []
}

let ticketGroups = {
  fieldKey: "ticket_groups",
  label: strings.form.appointmentAction.ticketGroups.label,
  type: "dropdownMultiEntityAlt",
  disabled: (getValues) => getValues()["all_ticket_group"] === true,
  showOnDisabled: (getValues) => getValues()["all_ticket_group"] === false,

  validators: [],

  showEmpty: true,
  storage: "redux",
  shareStorage: true,
  loader: {
    id: "ticketGroups",
    loader: fetchTicketGroups,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let allProductFamily = {
  fieldKey: "all_product_family",
  type: "switch",
  label: strings.form.appointmentAction.allProductFamily.label,
  validators: []
}

let productFamilies = {
  fieldKey: "product_families",
  label: strings.form.appointmentAction.productFamilies.label,
  type: "dropdownMultiEntityAlt",
  disabled: (getValues) => getValues()["all_product_family"] === true,
  showOnDisabled: (getValues) => getValues()["all_product_family"] === false,

  validators: [],

  showEmpty: true,
  storage: "redux",
  shareStorage: true,
  loader: {
    id: "productFamilies",
    loader: fetchFamilies,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let allProductSubFamily = {
  fieldKey: "all_product_sub_family",
  type: "switch",
  label: strings.form.appointmentAction.allProductSubFamily.label,
  validators: []
}

let productSubFamilies = {
  fieldKey: "product_sub_families",
  label: strings.form.appointmentAction.productSubFamilies.label,
  type: "dropdownMultiEntityAlt",
  disabled: (getValues) => getValues()["all_product_sub_family"] === true,
  showOnDisabled: (getValues) => getValues()["all_product_sub_family"] === false,

  validators: [],

  showEmpty: true,
  storage: "redux",
  shareStorage: true,
  filterOptions: (item, getValues, getExtraValues) => {
    let values = getValues(0);
    if(values["all_product_family"] === true) {
      return true;
    }

    if(Array.isArray(values["product_families"]) && values["product_families"].some(productSubFamily => productSubFamily["id"] === item["product_family"]["id"])) {
      return true;
    }

    if(typeof values["product_families"] === "object" && Object.keys(values["product_families"]).some(productSubFamilyId => Number(productSubFamilyId) === Number(item["product_family"]["id"]) && values["product_families"][productSubFamilyId] === true)) {
      return true;
    }

    return false;
  },
  loader: {
    id: "productSubFamilies",
    loader: fetchSubFamilies,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => typeof data === 'object' && data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => `${data["product_family"]?data["product_family"]["name"]+" > ":""}${data["name"]}`,
  },
}

// product_sub_families

export const filtersForm = {
  formKey: "appointmentAction",
  fields: [
    allTicketGroup,
    ticketGroups,
    allProductFamily,
    productFamilies,
    allProductSubFamily,
    productSubFamilies
  ]
}

export const previousPricesForm = {
  formKey: "appointmentAction",
  fields: [
    price,
    quantityCredit,
    lastPriceModifiedAt,
    previousPrices
  ]
}

export const form = {
  formKey: "appointmentAction",
  fields: [
    name,
    code,
    description,
    price,
    quantityCredit,
    active
  ]
}
